<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <strong>Output #{{ outputIndex }}</strong>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12" :class="{'mb-4' : can_show_player}">
          <strong>Mount Name</strong> : {{ output.mount }}<br>
          <strong>Mount Format</strong> : <span class="text-uppercase">{{ output.format | output_format_filter }}</span><br>
          <strong>Bitrate</strong> : {{ output.bitrate }} kHhz<br>
        </div>
        <div v-if="can_show_player" class="col-12">
          <player-iframe-preview :item="output_with_player_data"
                                 :is-live-feed="true"
                                 :show-tools="false"
                                 layout-override="legacy"
                                 :show-embed-code="false"
                                 :show-listen-link="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiveFeedsMixin from "VueMixins/Feeds/LiveFeedsMixin";
import PlayerIframePreview from "VueComponents/PlayerIframePreview";
export default {
  components: { PlayerIframePreview },
  mixins: [LiveFeedsMixin],
  props: {
    liveFeedUuid: {
      type: String,
      required: true,
    },
    output: {
      type: Object,
      required: true,
    },
    outputIndex: {
      type: Number,
      required: true,
    },
    showPlayer: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      output_player_data: null,
    };
  },
  computed: {
    can_show_player() {
      return this.showPlayer && this.output_player_data;
    },
    output_with_player_data() {
      const output_copy = JSON.parse(JSON.stringify(this.output));

      if (this.output_player_data) {
        output_copy.player_data = this.output_player_data;
      } else {
        output_copy.player_data = null;
      }

      return output_copy;
    },
  },
  beforeMount() {
    if (this.showPlayer) {
      this.getOutputPlayerData();
    }
  },
  methods: {
    async getOutputPlayerData() {
      try {
        const response = await axios.get(`/api/v1/live-feeds/output-player-data/${this.liveFeedUuid}`, {
          params: { mount: this.output.mount },
        });
        this.output_player_data = response.data.data;
      } catch (error) {
        this.handleAxiosError(error, "Could not load player.");
      }
    },
  },
};
</script>
